
import { useState, useEffect } from 'react';

export default function TopBar() {
  const messages = [
    "1.250₺ ve üzeri alışverişlerde kargo ücretsiz!",
    "Tüm ürünlerde %10'a varan indirim fırsatı!",
    "Türkiye'nin en yenilikçi çocuk takviye markası"
  ];
  const [currentMsg, setCurrentMsg] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentMsg(prev => (prev + 1) % messages.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="bg-brand-700 text-white py-1.5 sm:py-2 px-3 sm:px-4">
      <div className="max-w-[1440px] mx-auto flex items-center justify-between text-xs sm:text-sm">
        <div className="flex items-center gap-3 sm:gap-6">
          <a
            href="tel:+905449793051"
            className="flex items-center gap-1.5 sm:gap-2 hover:text-brand-100 transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-line text-xs sm:text-sm"></i>
            </div>
            <span className="hidden sm:inline text-xs sm:text-sm">0 544 979 3051</span>
          </a>
          <a
            href="mailto:info@vitassoilac.com"
            className="flex items-center gap-1.5 sm:gap-2 hover:text-brand-100 transition-colors cursor-pointer"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line text-xs sm:text-sm"></i>
            </div>
            <span className="hidden md:inline text-xs sm:text-sm">info@vitassoilac.com</span>
          </a>
        </div>

        <div className="flex-1 text-center">
          <div className="relative h-5 overflow-hidden">
            {messages.map((msg, i) => (
              <span
                key={i}
                className="absolute inset-0 flex items-center justify-center text-[10px] sm:text-xs font-medium transition-all duration-500 px-2"
                style={{
                  transform: currentMsg === i ? 'translateY(0)' : 'translateY(100%)',
                  opacity: currentMsg === i ? 1 : 0,
                }}
              >
                {msg}
              </span>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          <div className="flex items-center gap-2 sm:gap-3">
            <a
              href="https://www.facebook.com/vitassoilac/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="hover:text-brand-100 transition-colors cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-facebook-fill text-xs sm:text-sm"></i>
              </div>
            </a>
            <a
              href="https://www.instagram.com/vitassoilacturkiye/"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="hover:text-brand-100 transition-colors cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-instagram-line text-xs sm:text-sm"></i>
              </div>
            </a>
          </div>
          <div className="hidden md:flex items-center gap-3 border-l border-white/30 pl-4">
            <a href="#" className="text-xs hover:text-brand-100 transition-colors cursor-pointer whitespace-nowrap">
              Yardım
            </a>
            <a href="#" className="text-xs hover:text-brand-100 transition-colors cursor-pointer whitespace-nowrap">
              İletişim
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
